import axios from '@axios'

const state = {
  slides: [],
  adminSlides: [],
}

const getters = {
  slides: state => state.slides,
  adminSlides: state => state.adminSlides,
}

const mutations = {
  SET_SLIDES(state, slides) {
    state.slides = slides
  },
  SET_ADMIN_SLIDES(state, slides) {
    state.adminSlides = slides
  },
}

const toFormData = slide => {
  const formData = new FormData()
  const textKeys = ['kicker', 'title', 'highlight']
  if (slide.image) formData.append('login_slide[image]', slide.image)
  textKeys.forEach(key => {
    if (slide[key] !== undefined) formData.append(`login_slide[${key}]`, slide[key] || '')
  })
  if (slide.active !== undefined) formData.append('login_slide[active]', slide.active ? 'true' : 'false')
  if (slide.bullets !== undefined) formData.append('login_slide[bullets]', JSON.stringify(slide.bullets || []))
  return formData
}

const actions = {
  async fetchLoginSlides({ commit }) {
    const { data } = await axios.get('/v1/login_slides', { skipErrorToast: true })
    commit('SET_SLIDES', data.data || [])
    return data.data || []
  },

  async fetchAdminLoginSlides({ commit }) {
    const { data } = await axios.get('/v1/login_slides', { params: { all: true } })
    commit('SET_ADMIN_SLIDES', data.data || [])
    return data.data || []
  },

  async createLoginSlide({ dispatch }, slide) {
    const { data } = await axios.post('/v1/login_slides', toFormData(slide), { skipErrorToast: true })
    await dispatch('fetchAdminLoginSlides')
    return data
  },

  async updateLoginSlide({ dispatch }, { id, ...slide }) {
    const { data } = await axios.put(`/v1/login_slides/${id}`, toFormData(slide), { skipErrorToast: true })
    await dispatch('fetchAdminLoginSlides')
    return data
  },

  async deleteLoginSlide({ dispatch }, id) {
    await axios.delete(`/v1/login_slides/${id}`, { skipErrorToast: true })
    await dispatch('fetchAdminLoginSlides')
  },

  async reorderLoginSlides({ commit }, ids) {
    const { data } = await axios.put('/v1/login_slides/reorder', { ids }, { skipErrorToast: true })
    commit('SET_ADMIN_SLIDES', data.data || [])
    return data.data || []
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
